<div
  
  >
<div class="fiter-dialog custom-dialog configure-view alerts-wrapper" role="dialog"
aria-labelledby="dialog1Title">
  <span class="close-button" [mat-dialog-close] = "'reload'"  role="button" tabindex="0">
    <img src="./assets/icons/icon_close.svg" alt="close" id="close-btn">
  </span>
  <div class="dialog-header">
    <div class="title" id="dialog1Title">{{ getTitle() | translate}} </div>
  </div>
  <div class="dialog-body pro-body" fxLayout="row" fxLayout.xs="column">
    <div class="flexitem customer-list" fxFlex="50" fxFlex.gt-md="30" fxFlex.md="40">
      <div *ngIf="this.response.customer?.callingFrom !== 'Dashboard' && !data.isCustomerDetail" class="drpdown">
        <app-hp-dropdown [data]="legendData" [list]="legendsList" (setValue)="legendEvent($event)" [hideError]="true"
          [fromFilterEvents]="true" [toggleClick]="false" (isOpen)="dropStatus($event)"></app-hp-dropdown>
      </div>
        <div class="scroll" [ngClass]="filterValue === 'all' ? ' customer-set' : 'alerts-scroll'">
        <div>
          <div *ngFor="let customer of customerList; let i =index">
            <a tabindex="0" role="link"><app-customer-accordian [selectedCustomerID]="selectedCustomerID " (click)="onRowClick(customer, i)"
              [customer]="customer" [index]=i [fromDialog]=true></app-customer-accordian></a>
          </div>
        </div>
       
      </div>
    </div>
    <div class="flexitem printer-list  bg-gray scroll" fxFlex="50" fxFlex.md="60" fxFlex.gt-md="70">
      <div class="customer-case-open" *ngIf="selectedCustomerOpenCaseCount > 0" [hidden] = "loader || hasNoLength || detail_set?.length == 0">
        <p [innerHTML]="'CHECK_OPEN_CASE' | translate:{customerName : selectedCustomerName }" (click)="onSubTextClick($event)"> {{selectedCustomerName}}</p>
       
      </div>
      <div class="flexitem scroll ">
        <div class="no-data-found" *ngIf="(detail_set?.length == 0 && !loader); else hasPrinter"
          [hidden]="loader || hasNoLength">
          {{'NO_RESULT'| translate}}!!!
        </div>

        <ng-template #hasPrinter>
          <div *ngFor="let printer of detail_set; let jj = index" [class.last] = "detail_set.length - 1 == jj">
            <div *ngIf="printer?.deviceCategory" class="title2">{{printer?.deviceCategory}}</div>
            <div class="customer-details">
              <div *ngIf="printer.printer_name">
                <div class="customer-info">
                  <div class="flex-center printer-info">
                    <a class="link-styles" (click)="navigateToPrinterDetail(printer)" rel="noopener" role="link" href="javascript:void(0)">
                      <span>{{printer.printer_name}}</span></a>
                  </div>
                  <div>

                  </div>
                  <span>
                    <span *ngIf="getDeviceStatus(printer) != '-'" class="circle"
                      [ngStyle]="{'background-color': getStatusColor(printer)}"></span>
                    <span class="status-text">{{ getDeviceStatus(printer) }}</span>
                  </span>
                </div>
                <div class="sn">{{printer?.display_name}} - <span>{{'CASE_DETAIL.PRINTER_INFO.SERIAL_NUM' |
                    translate}}</span> <span>{{printer?.sn}}</span></div>

              </div>
              <div class="event-list" *ngFor="let alert of printer?.actions; index as i" id="accordionGroup">
                <div class="event-info" [attr.aria-expanded]="alert.isShow"  aria-controls="sect1" id="accordion1id"  (click)="accordianToggle(alert, printer)" role="link" tabindex="0">
                  <div class="flex-center list">
                    <span *ngIf="alert?.actionSeverity == 'InkLevel'">
                      <img class="ink-img"
                      src="./assets/icons/low_ink.svg" alt="InkLevel">
                    </span>
                    <span class="image-layer no-action-req" *ngIf="alert?.actionSeverity != 'InkLevel'"
                      [ngClass]="alert?.actionSeverity == 'Warning' ? 'no-action-req' : 'action-req'">
      
                      <img class="action-img" *ngIf="alert?.actionSeverity == 'Warning'"
                        src="./assets/icons/no_action_req.svg" alt="warning">
                      <img class="action-img" *ngIf="alert?.actionSeverity == 'Urgent'"
                        src="./assets/icons/action_req.svg" alt="urgent">
                    </span>
                    <div class="status">{{modifiedFormat(alert?.ruleType, alert?.userReplaceable) | translate | titlecase}} </div>
                    <span class="action-statement" [ngClass]="alert?.ruleType == 'SystemErrors' ? 'width2' : ''">
                      {{alert.actionDescription||'-'}}
                    </span>
                    <span class="spacer"></span>
                    <span> {{getTimeStamp(alert?.generateTs) | dateAgo }}</span>
                    <span class="toggle-arrow">
                      <img src="./assets/icons/icon_dropdown.svg"  [class.rotate]="alert.isShow" alt="dropdown icon">
                    </span>
                  </div>
                  <div>

                  </div>
                </div>
                <div [ngClass]="alert.isShow ? 'show':'hide'" role="region" aria-labelledby="accordion1id" id="sect1" >

                  <ng-container *ngIf="alert.actionSeverity == 'InkLevel';else nonInk">
                    <div class="statement1">{{alert.reasonWhy}}</div>
                     <div class="ink-color" *ngFor="let item of alert.ink_low_color">
                       {{item.product_number}} {{item.color}}
                     </div>
                     <!-- For inklevel hide the close action -->
                     <div class="case-detail "*ngIf="alert.actionSeverity !== 'InkLevel'" >
                      <span class="case-statement"
                        [style.width]="'100%'">{{alert.closureDescription}}</span>

                      <div class="btn-set">
                        <button id="proactive-alerts-popup-cancel-btn"
                          class="hp-secondary-btn" (click)="closeAction(alert)">{{'PROACTIVE_ALERT_PAGE.CLOSE' |
                          translate}}</button>
                      </div>
                      </div>
                  </ng-container>

                  <ng-template #nonInk>
                    <div class="spinner" style="margin: 1rem">
                      <mat-spinner mode="indeterminate" *ngIf="solutionLoader && ( selectedAlertID == alert?.actionUuid)"
                        style="margin:0 auto;" [diameter]="35"></mat-spinner>
                    </div>
  
                    <ng-container *ngIf="!solutionLoader">
                      <div>
                        <div class="statement1">{{alert.reasonWhy}}</div>
                        <span class="statement2"
                          *ngIf="alert?.solutionURL">{{'PROACTIVE_ALERT_PAGE.REASON_WHY.LEARN_STATEMENT'| translate}} <a
                            [href]="alert?.solutionURL" target="_blank" (click)="onClickSolutionURL(alert, printer)">
                            <span
                              *ngIf="alert?.ruleType != 'SystemErrors'">{{'PROACTIVE_ALERT_PAGE.REASON_WHY.RELATED_DOCUMENTATION'|
                              translate}}</span>
                            <span
                              *ngIf="alert?.ruleType == 'SystemErrors'">Troubleshooting instruction</span>
                          </a></span>
                        <span class="statement2" *ngIf="!alert?.solutionURL">
                          <span *ngIf="alert.has500Err">{{'PROACTIVE_ALERT_PAGE.SERVER_ERROR' | translate}}</span>
                          <span *ngIf="alert.has400Err">{{'PROACTIVE_ALERT_PAGE.NO_DATA' | translate}}</span>
                        </span>
                      </div>
  
                      <div class="case-detail">
                        <span class="case-statement"
                          [style.width]="alert?.ruleType != 'TargetedAction' ? '100%' : '60%'">{{alert.closureDescription}}</span>
  
                        <div class="btn-set">
                          <button id="proactive-alerts-popup-cancel-btn" *ngIf="alert?.ruleType == 'TargetedAction'" [hidden]="alert?.hideCloseAction"
                            class="hp-secondary-btn" (click)="closeAction(alert)">{{'PROACTIVE_ALERT_PAGE.CLOSE' |
                            translate}}</button>
                          <ng-container *ngIf="alert.caseID == null; else hasID">
                            <button id="proactive-alerts-popup-createcase-btn" class="hp-primary-btn btn-space-left"
                              (click)="createCase(alert, printer)"> {{'CUSTOMER_DETAILS.CASE' | translate}}</button>
                          </ng-container>
                          <ng-template #hasID>
                            <button id="proactive-alerts-popup-viewcase-btn" class="hp-secondary-btn btn-space-left"
                              (click)="viewCase(alert)">{{'HISTORY_PAGE.INFO.VIEW_CASE' | translate}}</button>
                          </ng-template>
                        </div>
                      </div>
                      <div class="feedback" *ngIf="!feedbackStatus && (alert?.ruleType == 'SystemErrors')">
                        <span> {{'PROACTIVE_ALERT_PAGE.FEEDBACK.TITLE' | translate}}</span>
                        <span (click)="feedbackSelected('true', alert)" class="feedback-btn">{{'BUTTONS.YES' |
                          translate}}</span>
                        <span (click)="feedbackSelected('false', alert)" class="feedback-btn">{{'BUTTONS.NO' |
                          translate}}</span>
                      </div>
                    </ng-container>
                  </ng-template>





                </div>
              </div>
            </div>
          </div>
        </ng-template>


        <div [ngClass]="!customerList.length && loader ? 'customer-set1' : ''" style="min-width: 400px;">
          <div class="spinner tp">
            <mat-spinner *ngIf="loader || hasNoLength" style="margin:0 auto;" [diameter]="35"></mat-spinner>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>